<div class="grid-x align-middle">
  <div class="cell" [ngClass]="{'small-12' : !haveButtons, 'small-6': haveButtons}">
    @if (!subHeader.showBreadCrumbs) {
      <h1 class="white no-margin-bottom" [innerHTML]="subHeader.title"></h1>
    }
    @if (subHeader.showBreadCrumbs) {
      <breadcrumbs curTab="form"></breadcrumbs>
    }
  </div>
  @if (haveButtons) {
    <div class="cell small-6">
      <div class="text-align-right">
        @for (button of subHeader.buttons; track button) {
          <button class="button margin-left no-margin-bottom outline-offset-1" (click)="invokeButton(button)" [disabled]="button.disabled()">{{button.name}}</button>
        }
      </div>
    </div>
  }
</div>

